module.exports = [
  'AT',
  'BE',
  'BG',
  'CH',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FO',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'TR',
  'AD',
  'AX',
  'BY',
  'EU',
  'FX',
  'GG',
  'GI',
  'IM',
  'JE',
  'LI',
  'MC',
  'MD',
  'ME',
  'MK',
  'SJ',
  'SM',
  'UA',
  'VA',
  'IT',
  'CY',
  'GL',
  'IS',
]
